module.exports = __webpack_public_path__ + "static/server-50426b83005c04bc0cb144fae9b66c60.png";